import type { ButtonPropsTypes } from '@Shelly/shelly-design-system/index';

// Device Side Panel View Types
export enum DeviceSidePanelView {
	BASIC = 1,
	ADVANCED = 2,
}

// Tabs Manager Types
export enum TabId {
	MAIN = 'main',
	TIMING = 'timing',
	SCHEDULE = 'schedule',
	SCRIPTS = 'scripts',
	VIRTUAL_COMPONENTS = 'virtual_components',
	HISTORY = 'history',
	STATISTICS = 'statistics',
	NOTIFICATIONS = 'notifications',
	ADDONS = 'addons',
	ACTIVITY_LOG = 'activity_log',
	SECONDARY_CONTROLS = 'secondary_controls',
	AMBIENT_LIGHT = 'ambient_light',
	DEVICES = 'devices',
	INFO = 'info',
	PLAY = 'play',
	EVENTS = 'events',
	FIND_ME = 'find_me',
	IRRIGATION = 'irrigation',
	CAMERA_RECORDINGS = 'camera_recordings',
	CAMERA_ZONES = 'camera_zones',
	TARIFF = 'tariff',
}

export type BaseTab = {
	id: TabId;
	icon: string;
	component: any;
};

export interface TabsState {
	tabIndex: number;
	openedEventTimestamp: number | null;
	activeHistoryButton: number | null;
}

export type TabClickEvent = CustomEvent<{ index: number }>;

export type SidepanelStickyBottomProps = {
	onClick: () => void;
	loading: boolean;
	disabled: boolean;
	label?: string;
	icon?: string;
	secondaryButton?: {
		onClick: () => void;
		label: string;
		variant?: ButtonPropsTypes['variant'];
		icon?: string;
		disabled?: boolean;
	};
	gap?: string;
};
